export const TESTIMONIALS = [
  {
    id: 1,
    testimonial: 'The best way to find a home. Simple, efficient, and accurate.',
    name: 'Hans Meier',
    address: 'Sihlquai 10, 8005 Zürich',
    rooms: '3 Bedrooms',
    type: 'Rent'
  },
  {
    id: 2,
    testimonial: 'HomeAI cut my search time in half—no more scrolling for hours.',
    name: 'Anna Müller',
    address: 'Rue du Rhône 42, 1204 Genève',
    rooms: '2 Bedrooms',
    type: 'Buy'
  },
  {
    id: 3,
    testimonial: 'Finally, property advice that factors in taxes and commute!',
    name: 'Luca Rossi',
    address: 'Via Nassa 21, 6900 Lugano',
    rooms: '3 Bedrooms',
    type: 'Rent'
  },
  {
    id: 4,
    testimonial: 'I asked; it delivered—perfect flat, perfect price.',
    name: 'Sophie Keller',
    address: 'Bundesgasse 3, 3011 Bern',
    rooms: '2 Bedrooms',
    type: 'Buy'
  },
  {
    id: 5,
    testimonial: 'From first chat to signed lease in a week. Brilliant.',
    name: 'Markus Steiner',
    address: 'Freie Strasse 70, 4001 Basel',
    rooms: '4 Bedrooms',
    type: 'Rent'
  },
  {
    id: 6,
    testimonial: 'Loved the childcare-distance filter—lifesaver for parents.',
    name: 'Claire Dubois',
    address: 'Rue de Bourg 22, 1003 Lausanne',
    rooms: '3 Bedrooms',
    type: 'Buy'
  },
  {
    id: 7,
    testimonial: 'Found a lake-view flat and cut CHF 200 in monthly taxes.',
    name: 'Nicolas Gerber',
    address: 'Pilatusstrasse 6, 6003 Luzern',
    rooms: '3 Bedrooms',
    type: 'Rent'
  },
  {
    id: 8,
    testimonial: 'The only search that matched my cycling commute.',
    name: 'Giulia Bernasconi',
    address: 'Brunngasse 19, 3600 Thun',
    rooms: '2 Bedrooms',
    type: 'Buy'
  },
  {
    id: 9,
    testimonial: 'Accurate, personal, and actually fun to use.',
    name: 'Jonas Schmid',
    address: 'Bahnhofplatz 2, 8400 Winterthur',
    rooms: '1 Bedroom',
    type: 'Rent'
  },
  {
    id: 10,
    testimonial: 'Showed me a suburb I’d never considered—now I love it.',
    name: 'Aurélie Favre',
    address: 'Avenue du Théâtre 7, 1005 Lausanne',
    rooms: '4 Bedrooms',
    type: 'Buy'
  },
  {
    id: 11,
    testimonial: 'Every suggestion came with crystal-clear cost breakdowns.',
    name: 'Peter Brunner',
    address: 'Löwenstrasse 16, 6004 Luzern',
    rooms: '2 Bedrooms',
    type: 'Rent'
  },
  {
    id: 12,
    testimonial: 'Best pet-friendly filter I’ve seen—my Labrador approves.',
    name: 'Sandro Bianchi',
    address: 'Corso San Gottardo 5, 6830 Chiasso',
    rooms: '3 Bedrooms',
    type: 'Buy'
  },
  {
    id: 13,
    testimonial: 'Switched from frustration to keys-in-hand in two weeks.',
    name: 'Laura Huber',
    address: 'Marktgasse 25, 3011 Bern',
    rooms: '2 Bedrooms',
    type: 'Rent'
  },
  {
    id: 14,
    testimonial: 'It even warned me about future tram extensions—genius.',
    name: 'Pascal Vogel',
    address: 'Claraplatz 2, 4057 Basel',
    rooms: '4 Bedrooms',
    type: 'Buy'
  },
  {
    id: 15,
    testimonial: 'Night-owl feature found a flat on the ZVV night-bus line.',
    name: 'Miriam Keller',
    address: 'Badenerstrasse 171, 8003 Zürich',
    rooms: '1 Bedroom',
    type: 'Rent'
  },
  {
    id: 16,
    testimonial: 'Real-time vacancy insights saved me bidding wars.',
    name: 'Lionel Rey',
    address: 'Rue du Stand 25, 1204 Genève',
    rooms: '3 Bedrooms',
    type: 'Buy'
  },
  {
    id: 17,
    testimonial: 'I love that it remembers my fave cafés when I return.',
    name: 'Nadine Christen',
    address: 'Gerbergasse 18, 4001 Basel',
    rooms: '2 Bedrooms',
    type: 'Rent'
  },
  {
    id: 18,
    testimonial: 'No hidden costs—every fee spelled out up front.',
    name: 'Fabio Cattaneo',
    address: 'Piazza Riforma 3, 6900 Lugano',
    rooms: '3 Bedrooms',
    type: 'Buy'
  },
  {
    id: 19,
    testimonial: 'From balcony sun-exposure to broadband speed—spot on.',
    name: 'Céline Blanc',
    address: 'Rue Saint-Pierre 8, 1700 Fribourg',
    rooms: '2 Bedrooms',
    type: 'Rent'
  },
  {
    id: 20,
    testimonial: 'The commute timer alone is worth the subscription.',
    name: 'David Baumann',
    address: 'Bahnhofstrasse 10, 9000 St. Gallen',
    rooms: '4 Bedrooms',
    type: 'Buy'
  },
  {
    id: 21,
    testimonial: 'Green-space index helped me land near my running trail.',
    name: 'Jasmin Schärer',
    address: 'Zürcherstrasse 45, 9500 Wil',
    rooms: '2 Bedrooms',
    type: 'Rent'
  },
  {
    id: 22,
    testimonial: 'Turned my vague wish list into a signed contract.',
    name: 'Olivier Perret',
    address: 'Place Pury 4, 2000 Neuchâtel',
    rooms: '3 Bedrooms',
    type: 'Buy'
  },
  {
    id: 23,
    testimonial: 'Five minutes to kindergarten—exactly as promised.',
    name: 'Martina Vogel',
    address: 'Rigistrasse 2, 6006 Luzern',
    rooms: '3 Bedrooms',
    type: 'Rent'
  },
  {
    id: 24,
    testimonial: 'Saved me CHF 400 a month in combined taxes and commute.',
    name: 'Adrian Küng',
    address: 'Römerstrasse 8, 8400 Winterthur',
    rooms: '2 Bedrooms',
    type: 'Buy'
  },
  {
    id: 25,
    testimonial: 'Interface is so intuitive my parents used it, too.',
    name: 'Beatrice Rüegg',
    address: 'Hauptstrasse 11, 4102 Binningen',
    rooms: '1 Bedroom',
    type: 'Rent'
  },
  {
    id: 26,
    testimonial: 'Spotted energy-efficient heating—and lower bills!',
    name: 'Renato Moser',
    address: 'Spitalgasse 38, 3011 Bern',
    rooms: '4 Bedrooms',
    type: 'Buy'
  },
  {
    id: 27,
    testimonial: 'Seamless, from first chat to handing over the deposit.',
    name: 'Eva Bühler',
    address: 'Steinenvorstadt 22, 4051 Basel',
    rooms: '2 Bedrooms',
    type: 'Rent'
  },
  {
    id: 28,
    testimonial: 'Air-quality score convinced me to move from the city.',
    name: 'Samuel Frei',
    address: 'Zugerstrasse 5, 6340 Baar',
    rooms: '3 Bedrooms',
    type: 'Buy'
  },
  {
    id: 29,
    testimonial: 'Love how it ranks noise levels street-by-street.',
    name: 'Isabella Bürki',
    address: 'Langstrasse 112, 8004 Zürich',
    rooms: '1 Bedroom',
    type: 'Rent'
  },
  {
    id: 30,
    testimonial: 'Rated school routes for safety—parent peace-of-mind.',
    name: 'Thierry Monnier',
    address: 'Avenue d’Ouchy 15, 1006 Lausanne',
    rooms: '3 Bedrooms',
    type: 'Buy'
  },
  {
    id: 31,
    testimonial: 'My relocation package felt effortless with HomeAI.',
    name: 'Daniela Steiner',
    address: 'Klosterstrasse 7, 6003 Luzern',
    rooms: '2 Bedrooms',
    type: 'Rent'
  },
  {
    id: 32,
    testimonial: 'It predicted market demand—helped me bid just right.',
    name: 'Pascal Lenz',
    address: 'Marktgasse 14, 2502 Biel/Bienne',
    rooms: '3 Bedrooms',
    type: 'Buy'
  },
  {
    id: 33,
    testimonial: 'Switched languages seamlessly—great for expats.',
    name: 'Chiara Conti',
    address: 'Viale Franschini 2, 6500 Bellinzona',
    rooms: '2 Bedrooms',
    type: 'Rent'
  },
  {
    id: 34,
    testimonial: 'Found fibre-optic internet where I least expected it.',
    name: 'Andreas Maurer',
    address: 'Industriestrasse 18, 6300 Zug',
    rooms: '3 Bedrooms',
    type: 'Buy'
  },
  {
    id: 35,
    testimonial: 'Best balcony sun-tracker—my tomatoes are thriving!',
    name: 'Eliane Schmid',
    address: 'Postgasse 30, 3011 Bern',
    rooms: '1 Bedroom',
    type: 'Rent'
  },
  {
    id: 36,
    testimonial: 'Zero spam, only real matches—love the focus.',
    name: 'Roberto De Luca',
    address: 'Via Pestariso 4, 6612 Ascona',
    rooms: '2 Bedrooms',
    type: 'Buy'
  },
  {
    id: 37,
    testimonial: 'It even flags future construction noise. Genius.',
    name: 'Janine Gasser',
    address: 'Obertor 12, 8400 Winterthur',
    rooms: '3 Bedrooms',
    type: 'Rent'
  },
  {
    id: 38,
    testimonial: 'Got a lakeside view under budget—unbelievable!',
    name: 'Sébastien Rochat',
    address: 'Quai Perdonnet 5, 1800 Vevey',
    rooms: '2 Bedrooms',
    type: 'Buy'
  },
  {
    id: 39,
    testimonial: 'Renting with pets was painless for once.',
    name: 'Katrin Arnold',
    address: 'Baslerstrasse 15, 8500 Frauenfeld',
    rooms: '3 Bedrooms',
    type: 'Rent'
  },
  {
    id: 40,
    testimonial: 'The tax savings alone paid for the subscription.',
    name: 'Olivier Ziegler',
    address: 'Rathausgasse 9, 6004 Luzern',
    rooms: '4 Bedrooms',
    type: 'Buy'
  },
  {
    id: 41,
    testimonial: 'Maps my gym, office, and favourite bakery—perfect.',
    name: 'Lea Graf',
    address: 'Hohlstrasse 85, 8004 Zürich',
    rooms: '1 Bedroom',
    type: 'Rent'
  },
  {
    id: 42,
    testimonial: 'Real photos plus AI-tagged features—no surprises.',
    name: 'Jérôme Martin',
    address: 'Rue des Alpes 12, 1201 Genève',
    rooms: '2 Bedrooms',
    type: 'Buy'
  },
  {
    id: 43,
    testimonial: '‘Too small’ feedback button worked like magic.',
    name: 'Sabina Egger',
    address: 'Bahnhofstrasse 3, 3000 Bern',
    rooms: '3 Bedrooms',
    type: 'Rent'
  },
  {
    id: 44,
    testimonial: 'Uncovered an up-and-coming area before prices spiked.',
    name: 'Christoph Imhof',
    address: 'Freiestrasse 29, 3012 Bern',
    rooms: '4 Bedrooms',
    type: 'Buy'
  },
  {
    id: 45,
    testimonial: 'Filtered listings by night-bus routes—brilliant!',
    name: 'Paola Lombardi',
    address: 'Via Cattedrale 9, 6900 Lugano',
    rooms: '2 Bedrooms',
    type: 'Rent'
  },
  {
    id: 46,
    testimonial: 'My landlord used it, too—says it’s a game-changer.',
    name: 'Reto Sutter',
    address: 'Rheingasse 31, 4058 Basel',
    rooms: '3 Bedrooms',
    type: 'Buy'
  },
  {
    id: 47,
    testimonial: 'The free trial hooked me; the insights kept me.',
    name: 'Mélanie Hofer',
    address: 'Rue des Terres-Rouges 6, 1950 Sion',
    rooms: '2 Bedrooms',
    type: 'Rent'
  },
  {
    id: 48,
    testimonial: 'Great balance of data science and human feel.',
    name: 'Urs Widmer',
    address: 'Gotthardstrasse 18, 6410 Goldau',
    rooms: '3 Bedrooms',
    type: 'Buy'
  },
  {
    id: 49,
    testimonial: 'I finally understand my total living costs.',
    name: 'Heidi Brunner',
    address: 'Dorfstrasse 4, 3700 Spiez',
    rooms: '2 Bedrooms',
    type: 'Rent'
  },
  {
    id: 50,
    testimonial: 'Energy-label filter saved me future heating shocks.',
    name: 'Alain Berthoud',
    address: 'Rue du Pont 12, 1347 Le Lac de Joux',
    rooms: '4 Bedrooms',
    type: 'Buy'
  },
  {
    id: 51,
    testimonial: 'My relocation to Basel was stress-free thanks to HomeAI.',
    name: 'Caroline Gisler',
    address: 'Aeschenvorstadt 57, 4051 Basel',
    rooms: '2 Bedrooms',
    type: 'Rent'
  },
  {
    id: 53,
    testimonial: 'Matched me to a quiet street two minutes from nightlife.',
    name: 'Yvonne Klauser',
    address: 'Stauffacherstrasse 35, 8004 Zürich',
    rooms: '1 Bedroom',
    type: 'Rent'
  },
  {
    id: 54,
    testimonial: 'Clever commute calculator saved me two hours weekly.',
    name: 'Tobias Stadelmann',
    address: 'Ringstrasse 11, 4600 Olten',
    rooms: '3 Bedrooms',
    type: 'Buy'
  },
  {
    id: 55,
    testimonial: 'Love that it adapts in real time as my needs change.',
    name: 'Emilie Berset',
    address: 'Grand-Rue 6, 1700 Fribourg',
    rooms: '2 Bedrooms',
    type: 'Rent'
  },
  {
    id: 56,
    testimonial: 'Surface parking? Underground? It nailed my preference.',
    name: 'Bruno Portmann',
    address: 'Kirchstrasse 10, 8406 Winterthur',
    rooms: '3 Bedrooms',
    type: 'Buy'
  },
  {
    id: 57,
    testimonial: 'Quick, clear, and spot-on budget recommendations.',
    name: 'Flurina Caduff',
    address: 'Poststrasse 5, 7000 Chur',
    rooms: '2 Bedrooms',
    type: 'Rent'
  },
  {
    id: 58,
    testimonial: 'Found a flat near my parents without extra commute.',
    name: 'René Pfister',
    address: 'Spitalstrasse 9, 3008 Bern',
    rooms: '4 Bedrooms',
    type: 'Buy'
  },
  {
    id: 59,
    testimonial: 'Interface works flawlessly on mobile—search on the go!',
    name: 'Selina Hauser',
    address: 'Kirchplatz 1, 6004 Luzern',
    rooms: '1 Bedroom',
    type: 'Rent'
  },
  {
    id: 60,
    testimonial: 'Best home-search tool in Switzerland—full stop.',
    name: 'Patrick Keller',
    address: 'Schützengasse 12, 8001 Zürich',
    rooms: '3 Bedrooms',
    type: 'Buy'
  }
];
